<div class="table-responsive">
  <table class="table table-striped table-hover">
    <thead>
    <tr>
      <th scope="col">ID</th>
      <th scope="col">Nummer</th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let geschaeft of list" [routerLink]="'./' + geschaeft.id" class="navigation-table__row">
      <td>{{geschaeft.id}}</td>
      <td>{{geschaeft.nummer}}</td>
    </tr>
    </tbody>
  </table>
</div>
